/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router'
import PageTitle from '../../../../client/js/components/PageTitle'
import useQueryParams from '../../../../client/js/hooks/useQueryParams'
import ProspectingListCard, { ProspectingListQuery } from '../prospecting/ProspectingListCard'
import { Container } from '@mantine/core'
import { getProspectingCreateLink } from '../../lib/links/prospectingLinks'
import Page from '../../../../client/js/components/Page'
import { useRouteLoaderData } from '../../../../client/js/components/RouteLoaderData'
import CustomerBreadcrumb from './CustomerBreadcrumb'

function CustomerProspectingListPage () {
  const intl = useIntl()
  const params = useParams<{ id: string }>()
  const customerId = parseInt(params.id, 10)
  const customer = useRouteLoaderData<Customer>()

  const [searchParams, setSearchParams] = useQueryParams()
  const searchQuery: ProspectingListQuery = useMemo(() => ({
    ...searchParams,
    customerId: params.id
  }), [params.id, searchParams])

  const title = intl.formatMessage({
    id: 'prospecting_list',
    defaultMessage: 'Prospections'
  })

  return (
    <Page>
      <Container size="xl">
        <PageTitle
          hidden
          title={title}
        />

        <CustomerBreadcrumb
          customer={customer}
          title={title}
        />

        <ProspectingListCard
          createLink={getProspectingCreateLink({ customerId })}
          query={searchQuery}
          onQueryChange={setSearchParams}
        />
      </Container>
    </Page>
  )
}

export default CustomerProspectingListPage
